import type { TechFormValidationIssue } from "../models/tech-form-validation.models";

export function getCurrentTechFormValidationIssues(
  allIssues: TechFormValidationIssue[],
  step: number,
  isCompletedForm: boolean,
): TechFormValidationIssue[] {
  if (isCompletedForm) return [];
  return step === 9 ? allIssues : allIssues.filter((issue) => issue.section === step);
}
